import React from 'react';
import { useRouter } from '../../components';
import { SiteLink } from '../../components';

export function BottomDock(props) {
  const links = [
    { url: '/blog', title: 'BLOG', icon: 'NAVicon.png', iconHover: 'NAVicon-hover.png' },
    { url: '/reviews', title: 'REVIEWS', icon: 'NAVicon.png', iconHover: 'NAVicon-hover.png' },
    { url: '/faq', title: 'FAQ', icon: 'NAVicon.png', iconHover: 'NAVicon-hover.png' },
    { url: '', title: 'SHOP', icon: 'NAVicon.png', iconHover: 'NAVicon-hover.png' },
    { url: '/contact', title: 'CONTACT', icon: 'NAVicon.png', iconHover: 'NAVicon-hover.png' }
  ];

  //const path = usePath();
  const { pathname } = useRouter();

  const isCurrent = (link) => {
    return pathname && pathname.toLowerCase() === link.toLowerCase();
  }

  const linkElts = links.map((link, index) =>
    <li key={index} className={`bottomMenu__li ${isCurrent(link.url) ? 'selected' : ''}`}>
      {
        link.title === 'SHOP' ?
        <a href='https://all-smalls-test.myshopify.com' className={`bottomMenu__link bottomMenu__link--${index}`}>
          <div className="icon">
            <img className="normal" src={`/assets/navicons/${link.icon}`} alt={link.title} />
            <img className="selected" src={`/assets/navicons/${link.iconHover}`} alt={link.title} />
          </div>
          <div>{link.title}</div>
        </a> :
        <SiteLink to={link.url} className={`bottomMenu__link bottomMenu__link--${index}`}>
          <div className="icon">
            <img className="normal" src={`/assets/navicons/${link.icon}`} alt={link.title} />
            <img className="selected" src={`/assets/navicons/${link.iconHover}`} alt={link.title} />
          </div>
          <div>{link.title}</div>
        </SiteLink>
      }
    </li>
  );

  return (
    <>
      <nav className="bottomMenu">
        {/* <div className="bottomMenu__bg"></div> */}
        <ul className="bottomMenu__links">
          {linkElts}
        </ul>
      </nav>
    </>
  );
}

// target='_blank' rel="noopener noreferrer"